export const categories = [
  {
    id: "shoes",
    name: "Shoes",
    namePt: "Calçados",
    description: "Tênis e sapatilhas",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Luxury%20designer%20sneakers%20with%20metallic%20accents%20on%20cream%20marble%20surface%2C%20soft%20golden%20hour%20studio%20lighting%2C%20magazine%20editorial%20photography%2C%20elegant%20refined%20composition%2C%20warm%20champagne%20tones%2C%20high%20fashion%20product%20shot&width=440&height=400&seq=cat-shoes-v2-01&orientation=landscape",
  },
  {
    id: "hoodies",
    name: "Hoodies/Sweaters",
    namePt: "Moletons/Camisolas",
    description: "Casacos e sweats",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Oversized%20cashmere%20blend%20hoodie%20draped%20artfully%20on%20white%20linen%20backdrop%2C%20soft%20morning%20light%20from%20window%2C%20scandinavian%20minimalist%20aesthetic%2C%20cream%20and%20oatmeal%20tones%2C%20textured%20fabric%20detail%2C%20editorial%20fashion&width=440&height=400&seq=cat-hoodies-v2-02&orientation=landscape",
  },
  {
    id: "tshirts",
    name: "T-Shirts",
    namePt: "T-Shirts",
    description: "Camisetas casuais",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Organic%20cotton%20t-shirt%20folded%20neatly%20on%20rustic%20wooden%20surface%2C%20soft%20afternoon%20sunlight%20casting%20gentle%20shadows%2C%20earthy%20terracotta%20and%20sand%20palette%2C%20lifestyle%20product%20photography%2C%20Mediterranean%20aesthetic&width=440&height=400&seq=cat-tshirts-v2-03&orientation=landscape",
  },
  {
    id: "jackets",
    name: "Jackets",
    namePt: "Jaquetas",
    description: "Casacos e blusões",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Vintage%20leather%20bomber%20jacket%20on%20minimalist%20concrete%20display%2C%20dramatic%20side%20lighting%20creating%20deep%20contrast%2C%20editorial%20fashion%20photography%2C%20rich%20cognac%20brown%20tones%2C%20textured%20material%20closeup%2C%20luxury%20aesthetic&width=440&height=400&seq=cat-jackets-v2-04&orientation=landscape",
  },
  {
    id: "pants",
    name: "Pants/Shorts",
    namePt: "Calças/Shorts",
    description: "Calças e bermudas",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Tailored%20linen%20trousers%20elegantly%20draped%20on%20white%20ceramic%20stool%2C%20soft%20natural%20light%2C%20Mediterranean%20coastal%20vibe%2C%20warm%20sand%20and%20ivory%20palette%2C%20editorial%20lifestyle%20photography%2C%20breezy%20summer%20aesthetic&width=440&height=400&seq=cat-pants-v2-05&orientation=landscape",
  },
  {
    id: "headwear",
    name: "Headwear",
    namePt: "Chapéus/Bonés",
    description: "Bonés e gorros",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Designer%20baseball%20cap%20on%20smooth%20travertine%20stone%20surface%2C%20warm%20sunset%20light%2C%20minimalist%20product%20photography%2C%20dusty%20olive%20green%20fabric%2C%20refined%20streetwear%20aesthetic%2C%20clean%20shadows%2C%20editorial%20quality&width=440&height=400&seq=cat-headwear-v2-06&orientation=landscape",
  },
  {
    id: "sets",
    name: "Sets",
    namePt: "Conjuntos",
    description: "Kits completos",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20two-piece%20outfit%20displayed%20on%20minimal%20wooden%20hangers%2C%20bright%20airy%20studio%20with%20plants%2C%20soft%20neutral%20beige%20and%20cream%20tones%2C%20contemporary%20fashion%20editorial%2C%20clean%20Scandinavian%20design%20aesthetic&width=440&height=400&seq=cat-sets-v2-07&orientation=landscape",
  },
  {
    id: "underwear",
    name: "Underwear/Underpants",
    namePt: "Roupa Interior",
    description: "Cuecas e boxers",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20neatly%20folded%20on%20white%20egyptian%20cotton%20sheet%2C%20soft%20morning%20light%2C%20spa-like%20serene%20atmosphere%2C%20warm%20ivory%20tones%2C%20minimalist%20wellness%20photography%2C%20clean%20comfort%20aesthetic&width=440&height=400&seq=cat-underwear-v2-08&orientation=landscape",
  },
  {
    id: "jersey",
    name: "Jersey",
    namePt: "Camisolas",
    description: "Jerseys desportivas",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20soccer%20jersey%20displayed%20on%20minimal%20white%20mannequin%20torso%2C%20dramatic%20studio%20lighting%20from%20above%2C%20vibrant%20burgundy%20fabric%2C%20sports%20editorial%20photography%2C%20athletic%20energy%2C%20clean%20background&width=440&height=400&seq=cat-jersey-v2-09&orientation=landscape",
  },
  {
    id: "accessories",
    name: "Accessories",
    namePt: "Acessórios",
    description: "Bijuterias e relógios",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20gold%20jewelry%20set%20scattered%20on%20raw%20silk%20fabric%2C%20soft%20candlelight%20ambiance%2C%20luxurious%20editorial%20still%20life%2C%20warm%20amber%20and%20honey%20reflections%2C%20bohemian%20luxury%20aesthetic%2C%20intricate%20metal%20details&width=440&height=400&seq=cat-accessories-v2-10&orientation=landscape",
  },
  {
    id: "bags",
    name: "Bags",
    namePt: "Malas",
    description: "Mochilas e malas",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Italian%20leather%20tote%20bag%20standing%20on%20polished%20concrete%20floor%2C%20natural%20light%20from%20large%20window%2C%20architectural%20minimalist%20setting%2C%20rich%20espresso%20brown%20leather%2C%20editorial%20fashion%2C%20modern%20luxury&width=440&height=400&seq=cat-bags-v2-11&orientation=landscape",
  },
  {
    id: "belts",
    name: "Belts",
    namePt: "Cintos",
    description: "Cintos de couro",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Handcrafted%20leather%20belt%20coiled%20elegantly%20on%20dark%20slate%20surface%2C%20dramatic%20spotlight%20illumination%2C%20rich%20mahogany%20brown%20tones%2C%20artisan%20product%20photography%2C%20brass%20buckle%20detail%2C%20luxury%20accessories&width=440&height=400&seq=cat-belts-v2-12&orientation=landscape",
  },
  {
    id: "perfumes",
    name: "Perfumes",
    namePt: "Perfumes",
    description: "Fragrâncias",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Artisan%20perfume%20bottle%20with%20dried%20flowers%20on%20aged%20wooden%20table%2C%20soft%20diffused%20window%20light%2C%20French%20provincial%20aesthetic%2C%20warm%20amber%20liquid%20visible%2C%20vintage%20apothecary%20vibe%2C%20romantic%20editorial&width=440&height=400&seq=cat-perfumes-v2-13&orientation=landscape",
  },
  {
    id: "other",
    name: "Other Stuff",
    namePt: "Outros",
    description: "Diversos",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    imageUrl: "https://readdy.ai/api/search-image?query=Curated%20collection%20of%20lifestyle%20objects%20on%20white%20ceramic%20tray%2C%20bright%20natural%20light%2C%20contemporary%20home%20decor%20aesthetic%2C%20warm%20terracotta%20and%20sage%20green%20accents%2C%20minimalist%20still%20life%2C%20harmonious%20composition&width=440&height=400&seq=cat-other-v2-14&orientation=landscape",
  },
];